import { CartItem, PaymentMethod, ProductCategory, ProductWithStock } from "../../../domain/models";

export enum OperationMode {
  CART = "CART",
  REFUND = "REFUND"
}

export enum ReceiptStatus {
  ONGOING = "ONGOING",
  CANCELLED = "CANCELLED", 
  COMPLETED = "COMPLETED",
  REFUNDED = "REFUNDED",
  PARTIAL = "PARTIAL"
}

export interface Receipt {
  id: string;
  /** Backend sale visibleId used for refund API */
  saleVisibleId?: string;
  receiptNumber: string;
  items: CartItem[];
  subtotal: number;
  discountPercentage: number;
  discountAmount: number;
  taxAmount?: number;
  grandTotal: number;
  paymentMethod: PaymentMethod;
  cashGiven: number;
  cashReturned: number;
  cashierName: string;
  createdAt: Date;
  doneAt: Date | null;
  status: ReceiptStatus;
  /** Units already returned or exchanged, aligned with items. */
  returnedQuantities?: number[];
}

export default interface CashierSellingViewModelState {
  // Basic info
  receiptNumber: string;
  cashierName: string;
  currentDateTime: string; // Dynamic date/time updated every second
  operationMode: OperationMode;
  
  // Cart management
  cart: CartItem[];
  searchTerm: string;
  quantity: string;
  editingCartIndex: number | null;
  
  // Products and categories
  products: ProductWithStock[];
  specialSaleProducts: ProductWithStock[];
  freePriceCategories: ProductCategory[];
  categories: ProductCategory[];
  selectedCategoryId: string | null;
  isLoadingProducts: boolean;
  isLoadingCategories: boolean;
  
  // Pricing and totals
  subtotal: number;
  discountPercentage: number;
  discountAmount: number;
  /** TVA amount after remises (Figma calcCart) */
  taxAmount: number;
  grandTotal: number;
  
  // Payment processing
  paymentMethod: PaymentMethod;
  cashGiven: number;
  cashToReturn: number;
  isProcessingPayment: boolean;
  showPaymentModal: boolean;
  
  // Refund mode
  selectedReceipt: Receipt | null;
  receiptHistory: Receipt[];
  
  // Current receipt tracking
  currentReceipt: Receipt | null;
  
  // Cash keypad state
  cashKeypadValue: string;
  isEditingCashGiven: boolean;
  showCashKeypad: boolean;
  
  // Print confirmation
  shouldPrintReceipt: boolean;
  
  // UI state
  showSearchResults: boolean;
  notification: {
    message: string;
    type: 'success' | 'error' | 'info';
    show: boolean;
  };
  errors: {
    quantity: string;
    payment: string;
    general: string;
  };
} 